import * as React from 'react'
import { useEffect, useMemo, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Header } from '../../components/Layout/Header'
import { useI18n } from '../../lib/context/i18n'
import { Translation } from '../../lib/context/i18n/interfaces'
import { Wrapper } from './styled'
import { defaultLanguage, LANGUAGE } from '../../../config/storyblok/languages'

const navigationQuery = graphql`
  query {
    allStoryblokEntry(filter: { field_component: { eq: "Navigation" } }) {
      nodes {
        id
        name
        uuid
        lang
        content
      }
    }
  }
`

export const PageHeader = ({ subNavigation }: { subNavigation?: JSX.Element }) => {
  const [isSticky, setIsSticky] = useState(false)
  const [isTop, setIsTop] = useState(false)
  const pageNavigations = useStaticQuery(navigationQuery)

  const { currentLanguage } = useI18n()

  const allHeaderData = useMemo(() => {
    const mappedTranslations: Record<LANGUAGE, Translation> | {} = {}

    if (pageNavigations) {
      const { allStoryblokEntry: allStoryblokEntry } = pageNavigations

      allStoryblokEntry?.nodes?.forEach(source => {
        let key = source.lang === 'default' ? defaultLanguage : source.lang
        let value = source

        if (!mappedTranslations[key]) {
          mappedTranslations[key] = {}
        }

        mappedTranslations[key] = value
      })
    }

    return mappedTranslations
  }, [pageNavigations])

  useEffect(() => {
    let lastScrollY = 0

    const handleScroll = () => {
      const newScrollY = window.scrollY
      if (newScrollY > lastScrollY && !!subNavigation && newScrollY > 50) {
        setIsSticky(true)
      } else {
        setIsSticky(false)
      }
      lastScrollY = newScrollY
      setIsTop(newScrollY === 0)
    }

    handleScroll()

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [subNavigation])

  return (
    <Wrapper isTop={isTop} isSticky={isSticky}>
      {allHeaderData[currentLanguage] && (
        <Header headerData={allHeaderData[currentLanguage]} subNavigation={subNavigation} />
      )}
    </Wrapper>
  )
}

export default PageHeader
